import { Lock, Users } from 'lucide-react';

// Client-side labels. Internal comments stay within the client's team; shared ones are visible to Stratel.
const LABELS = {
  internal: 'Internal (your team only)',
  shared: 'Shared with Stratel',
};

export function VisibilityBadge({ comment }) {
  const fromStratel = comment?.team === 'internal' || comment?.authorRole === 'internal';
  if (fromStratel) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-[11px] font-medium text-blue-700">
        <Users size={11} /> From Stratel
      </span>
    );
  }
  const shared = comment?.visibility === 'shared';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${
        shared ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-700'
      }`}
    >
      {shared ? <Users size={11} /> : <Lock size={11} />}
      {shared ? LABELS.shared : LABELS.internal}
    </span>
  );
}

export function VisibilityToggle({ value, onChange }) {
  return (
    <div className="flex rounded-lg border border-secondary-300 p-0.5 text-xs" role="radiogroup" aria-label="Who can see this comment">
      {['internal', 'shared'].map((option) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={value === option}
          onClick={() => onChange(option)}
          className={`flex flex-1 items-center justify-center gap-1 rounded-md px-2 py-1 ${
            value === option
              ? option === 'shared' ? 'bg-green-600 text-white' : 'bg-secondary-700 text-white'
              : 'text-secondary-600 hover:bg-secondary-100'
          }`}
        >
          {option === 'shared' ? <Users size={12} /> : <Lock size={12} />}
          {LABELS[option]}
        </button>
      ))}
    </div>
  );
}
